import { useMemo } from 'react';

import type { IImageInlayProps } from './types';

import style from './styles.module.scss';

const ImageInlay = ({ imageSrc, alt = 'Inlay', ...restProps }: IImageInlayProps) => {
  const sources = useMemo(() => {
    if (typeof imageSrc === 'string') {
      return [imageSrc];
    }
    if (imageSrc && typeof imageSrc === 'object') {
      return Object.values(imageSrc).filter((src): src is string => {
        return typeof src === 'string' && src.trim() !== '';
      });
    }
    return [];
  }, [imageSrc]);

  if (sources.length === 0) {
    return null;
  }

  return (
    <div className={style.wrapper}>
      {sources.map((src, index) => {
        return (
          <div
            key={src}
            className={style.imageBox}
          >
            <img
              src={src}
              alt={`${alt} image ${index + 1}`}
              className={style.image}
              {...restProps}
            />
          </div>
        );
      })}
    </div>
  );
};

export default ImageInlay;
